import React from 'react';
import { format, subDays, addDays } from 'date-fns';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from 'recharts';

import GraphTitle from 'app/shared/components/Graphs/GraphTitle';

import './style.scss';

const TIME_SPAN = 7;

const GRAPH_TITLES = {
    CONTACTS: 'Contacts',
    VIEWS: 'Views',
    VIEWS_TO_CONTACT: 'Views to Contants Conversion Ratio',
};

const getDayKey = date => format(date, 'MM/DD');

const TrafficGraph = ({ properties }) => {
    let date = subDays(new Date(), TIME_SPAN - 1);
    const data = [];
    const bucketMap = {};
    for (let i = 0; i < TIME_SPAN; i += 1) {
        data.push({
            date: getDayKey(date),
            a: 4,
        });
        bucketMap[getDayKey(date)] = i;
        date = addDays(date, 1);
    }

    properties.forEach((property) => {
        property.timeSeries.forEach((dataPoint) => {
            const dateBucketKey = getDayKey(new Date(dataPoint.date));
            if (data[bucketMap[dateBucketKey]]) {
                data[bucketMap[dateBucketKey]][property.name] = dataPoint.contacts;
            }
        });
    });

    data.forEach((dataPoint) => {
        properties.forEach((property) => {
            if (typeof dataPoint[property.name] === 'undefined') {
                dataPoint[property.name] = 0;
            }
        });
    });

    return (
        <div className="TrafficGraph">
            <GraphTitle title={GRAPH_TITLES.CONTACTS} />
            <ResponsiveContainer width="100%" height={300}>
                <LineChart
                    data={data}
                >
                    <XAxis dataKey="date" />
                    <YAxis />
                    <CartesianGrid strokeDasharray="3 3" />
                    <Tooltip />
                    {properties.map((property, i) => (
                        <Line
                            key={i}
                            strokeOpacity={i === 0 ? 1 : 0.8}
                            type="linear"
                            dataKey={property.name}
                            strokeWidth={i === 0 ? 4 : 1}
                            stroke={i === 0 ? '#3dca5a' : '#006aff'}
                            isAnimationActive={false}
                        />
                    ))}
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
};

export default TrafficGraph;
